import { LOGO, INSTAGRAM } from "../../data";
import { scrollToId } from "./useLenis";

export const Footer = () => (
    <footer
        data-testid="footer"
        className="bg-hotpink text-white pt-16 pb-10 px-4 relative overflow-hidden"
    >
        <div
            className="absolute inset-0 opacity-10 pointer-events-none"
            style={{
                backgroundImage:
                    "radial-gradient(#fff 1.5px, transparent 1.5px)",
                backgroundSize: "24px 24px",
            }}
        />
        <div className="relative max-w-4xl mx-auto flex flex-col items-center text-center">
            <img
                src={LOGO.footer}
                alt="¡Qué Fresas! logo"
                data-testid="footer-logo"
                className="w-48 md:w-56 h-auto object-contain mb-8 rounded-2xl"
            />

            <nav className="flex flex-wrap justify-center gap-6 mb-8">
                <button
                    data-testid="footer-link-menu"
                    onClick={() => scrollToId("menu")}
                    className="font-display font-medium text-lg hover:text-lightpink transition-colors"
                >
                    Menú
                </button>
                <button
                    data-testid="footer-link-location"
                    onClick={() => scrollToId("ubicacion")}
                    className="font-display font-medium text-lg hover:text-lightpink transition-colors"
                >
                    Ubicación
                </button>
                <a
                    data-testid="footer-link-instagram"
                    href={INSTAGRAM}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="font-display font-medium text-lg hover:text-lightpink transition-colors"
                >
                    Instagram
                </a>
            </nav>

            <p className="font-display font-semibold text-2xl md:text-3xl">
                El capricho más dulce de León ✨
            </p>

            <p className="mt-8 text-white/70 text-sm">
                © {new Date().getFullYear()} ¡Qué Fresas! · Plaza Cortes
                Leonesas, León 🍓
            </p>
        </div>
    </footer>
);
